module.exports = __webpack_public_path__ + "img/tip_bg@2x.a240dd8f.png";